import { Link } from "react-router-dom";

const AdmissionDetails = () => {
  return (
    <section className="course-details py-60">
      <div className="container">
        <div className="row gy-4">
          <div className="col-xl-12">
            {/* Details Content Start */}
            <div className="course-details__content border border-neutral-30 rounded-12 bg-main-25 p-12">
              <div className="p-20">
                <h3 className="mt-24 mb-24">
                  NPS Kudlu (CBSE), Silver County Road, South Bangalore
                  <br /> Admissions are open for 2027-28
                </h3>
                <p className="text-neutral-700">
                  Looking for the{" "}
                  <b>
                    best CBSE school near Electronic City, Bangalore? At
                    National Public School, Kudlu,
                  </b>{" "}
                  we combine academic excellence with holistic development to
                  nurture confident, future-ready students.
                </p>
                <span className="d-block  my-32" />
                <h3 className="mb-16">Why choose NPS, Kudlu?</h3>
                <ul className="list-dotted d-flex flex-column gap-24">
                  <li>
                    <b> Prime Location:</b> Situated in Kudlu, South Bangalore,
                    just minutes away from Electronic City* and surrounding IT
                    hubs.
                  </li>
                  <li>
                    <b>CBSE Curriculum:</b> A well-structured academic program
                    focused on conceptual clarity and critical thinking.
                  </li>
                  <li>
                    <b>Experienced Faculty:</b> Highly qualified, caring
                    teachers who mentor students individually.
                  </li>
                  <li>
                    <b>World-Class Facilities:</b> Smart classrooms, science &
                    computer labs, sports infrastructure, and cultural activity
                    zones.
                  </li>
                  <li>
                    <b> Holistic Development:</b> Equal emphasis on academics,
                    sports, arts, leadership, and life skills.
                  </li>
                  <li>
                    <b>Convenient Transport:</b> Safe and reliable bus service
                    covering Electronic City, HSR Layout, Sarjapur Road, Begur,
                    and nearby areas.
                  </li>
                </ul>
                <span className="d-block  my-32" />
                <h4 className="mb-16">Eligibility & Age Criteria (2027–28)</h4>
                <ul className="list-dotted d-flex flex-column gap-24">
                  <li>
                    <b>Montessori Stream Age Criteria:</b>
                    <br />
                    <b>Freshers</b> - Child should complete 3 years on 1st June
                    2027
                    <br />
                    <b>Juniors</b> - Child should complete 4 years on 1st June
                    2027
                    <br />
                    <b>Seniors</b> - Child should complete 5 years on 1st June
                    2027
                  </li>
                  <li>
                    <b>Grade I: </b> Child should complete 6 years as on 1st
                    June 2027.
                  </li>
                </ul>
                <span className="d-block  my-32" />
                <h5 className="mb-16">Admission Process</h5>
                <ul className="list-dotted d-flex flex-column gap-24">
                  <li>
                    <b>Enquiry & Campus Visit</b>
                    <br />
                    1. Parents can fill out the online enquiry form or contact
                    the admissions office.
                    <br />
                    2. Campus tours are available to experience our
                    state-of-the-art facilities.
                  </li>
                  <li>
                    <b>Application Form</b>
                    <br />
                    1. Application forms are available online.
                    <br />
                    2. Submit the completed form with required documents.
                  </li>
                  <li>
                    <b>Interaction / Assessment</b> <br />
                    1. For Preprimary: Interaction with Child
                    and parents
                    <br />
                    2. Grades I to VIII: Admission Test followed by interaction
                    with Child and parents
                  </li>
                  <li>
                    <b>Confirmation</b> <br />
                    1. Selected candidates will be notified.
                    <br />
                    2. Admission is confirmed upon fee payment and document
                    verification.
                  </li>
                </ul>
                <span className="d-block  my-32" />
                <h6 className="mb-16">Documents Required</h6>
                <ul className="list-dotted d-flex flex-column gap-24">
                  <li>Birth Certificate</li>
                  <li>Previous school report card (if applicable)</li>
                  <li>Transfer Certificate (for Class II onwards)</li>
                  <li>Passport-size photos (student & parents)</li>
                  <li>Aadhaar Card (student & parents)</li>
                  <li>Proof of residence</li>
                </ul>
              </div>
              <div className="mb-0" align="center">
                <Link
                  to="https://npskudluacadamis.com/online-application/nps-kudlu"
                  target="_blank"
                  className="btn btn-main rounded-pill flex-center gap-8 mt-40 "
                  style={{ width: "200px" }}
                >
                  Apply Online
                  <i className="ph-bold ph-arrow-up-right d-flex text-lg" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdmissionDetails;
